// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__26SHi","inputWrap":"CustomTip_inputWrap__LX1Bz"};